import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import mainBackground from './img/intro311mobile-mainbackground.jpg'
import backgroundAndDesktop from './img/intro311desktop-and.png'
import goldenLeftDesktop from './img/intro311desktop-golden-left.png'
import goldenRightDesktop from './img/intro311desktop-golden-right.png'
import greenLeftDesktop from './img/intro311desktop-green-left.png'
import greenRightDesktop from './img/intro311desktop-green-right.png'
import backgroundAndMobile from './img/intro311mobile-and.png'
import goldenLeftMobile from './img/intro311mobile-golden-left.png'
import goldenRightMobile from './img/intro311mobile-golden-right.png'
import greenLeftMobile from './img/intro311mobile-green-left.png'
import greenRightMobile from './img/intro311mobile-green-right.png'
import intro311DesktopPath1 from './img/intro311desktop-path-11A88CE9-F4B0-456D-9AA2-950FEC29B13D@2x.png'
import intro311DesktopPath2 from './img/intro311desktop-path-13FC8C0E-F384-4FD0-BD51-01D3EF46C3B4@2x.png'
import intro311DesktopPath3 from './img/intro311desktop-path-34D918DF-65F8-4BD4-A1A7-FD1FBA5541AA@2x.png'
import intro311DesktopPath4 from './img/intro311desktop-path-12345930-C6A7-4A9D-83D0-43A57C0638F5@2x.png'
import intro311DesktopPath5 from './img/intro311desktop-path-AB8ED7F3-D286-484E-A913-F1BD5AFCAB1E@2x.png'
import intro311DesktopPath6 from './img/intro311desktop-path-CD7155B4-4B7C-4318-AABE-7DC97DFAC6C5@2x.png'
import intro311DesktopPath7 from './img/intro311desktop-shape-54353E1B-B33A-42B3-A477-DDA1A180C9D0@2x.png'
import intro311DesktopPath8 from './img/intro311desktop-shape-8443017A-D8EF-42E3-A826-9CC88E690D61@2x.png'
import intro311DesktopPath9 from './img/intro311desktop-shape-C17B4695-137E-4EB3-B4CB-B1FF170B2301@2x.png'
import intro311DesktopPath10 from './img/intro311desktop-shape-D49BFEEE-B690-4EE9-AB61-CD65067725F9@2x.png'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro319">
      <div className="intro311mobile screen">
        <img
          className="main-background-FMkp9I"
          src={background || mainBackground}
        />
        <img className="green-left-FMkp9I" src={greenLeftMobile} />
        <img className="green-right-FMkp9I" src={greenRightMobile} />
        <img className="golden-right-FMkp9I" src={goldenRightMobile} />
        <img className="golden-left-FMkp9I" src={goldenLeftMobile} />
        <div className="container-center-horizontal">
          <div className="button-FMkp9I">
            <div
              className="site-de-casamento-e-dLtx0w"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-dLtx0w" onClick={onSkipIntro}>
              <div className="button-KHJ0HW"></div>
              <div className="pular-introduo-KHJ0HW">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-vertical container-center-horizontal">
          <div className="content-FMkp9I bp1-animate-enter">
            <div className="mariana-hXq2XQ notranslate">
              {coupleSingleName.bride}
            </div>
            {coupleSingleName.groom && (
              <>
                <img className="and-hXq2XQ" src={backgroundAndMobile} />
                <div className="eduardo-hXq2XQ">{coupleSingleName.groom}</div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="intro311desktop screen">
        <img
          className="main-background-wArmXD"
          src={background || mainBackground}
        />
        <img className="green-right-wArmXD" src={goldenRightDesktop} />
        <img className="green-left-wArmXD" src={greenLeftDesktop} />
        <img className="golden-right-wArmXD" src={greenRightDesktop} />
        <img className="golden-left-wArmXD" src={goldenLeftDesktop} />
        <div className="container-center-horizontal">
          <div className="button-wArmXD">
            <div
              className="site-de-casamento-e-oq0nD4"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-oq0nD4" onClick={onSkipIntro}>
              <div className="button-PSMXdE"></div>
              <div className="pular-introduo-PSMXdE">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-vertical container-center-horizontal">
          <div className="content-wArmXD bp2-animate-enter">
            <div className="felizes-para-sempre-2onLpd">
              <img className="path-UdFVZF" src={intro311DesktopPath2} />
              <img className="shape-UdFVZF" src={intro311DesktopPath9} />
              <img className="path-p7aLYq" src={intro311DesktopPath6} />
              <img className="shape-p7aLYq" src={intro311DesktopPath10} />
              <img className="path-xXHReo" src={intro311DesktopPath1} />
              <img className="shape-xXHReo" src={intro311DesktopPath9} />
              <img className="path-7Ds7YQ" src={intro311DesktopPath4} />
              <img className="shape-7Ds7YQ" src={intro311DesktopPath8} />
              <img className="shape-NLUi2t" src={intro311DesktopPath7} />
              <img className="path-NLUi2t" src={intro311DesktopPath3} />
              <img className="shape-N8xaAB" src={intro311DesktopPath7} />
              <img className="path-N8xaAB" src={intro311DesktopPath4} />
              <img className="shape-LLN33R" src={intro311DesktopPath9} />
              <img className="path-LLN33R" src={intro311DesktopPath5} />
              <img className="shape-M8xOHy" src={intro311DesktopPath8} />
              <img className="path-M8xOHy" src={intro311DesktopPath3} />
              <img className="shape-PfpGQc" src={intro311DesktopPath9} />
            </div>
            <div className="group-2onLpd">
              <div className="mariana-Ul0yYl notranslate">
                {coupleSingleName.bride}
              </div>
              {coupleSingleName.groom && (
                <>
                  <img className="and-Ul0yYl" src={backgroundAndDesktop} />
                  <div className="eduardo-Ul0yYl">{coupleSingleName.groom}</div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
